import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b072632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cMaterial"
}
const _hoisted_2 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3168_9509)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.3035 12.9475L14.1252 11.7675L15.3035 10.5892C15.6932 10.2029 16.0028 9.74342 16.2144 9.23717C16.4261 8.73092 16.5357 8.18786 16.5369 7.63915C16.5381 7.09044 16.4309 6.5469 16.2214 6.03973C16.012 5.53255 15.7045 5.07174 15.3165 4.68375C14.9285 4.29575 14.4677 3.98821 13.9605 3.77878C13.4533 3.56936 12.9098 3.46217 12.3611 3.46337C11.8124 3.46457 11.2693 3.57414 10.7631 3.78578C10.2568 3.99743 9.79734 4.30699 9.41105 4.69668L8.23271 5.87584L7.05355 4.69751L8.23355 3.51918C9.32756 2.42516 10.8114 1.81055 12.3585 1.81055C13.9057 1.81055 15.3895 2.42516 16.4835 3.51918C17.5776 4.6132 18.1922 6.097 18.1922 7.64418C18.1922 9.19135 17.5776 10.6752 16.4835 11.7692L15.3035 12.9475ZM12.9469 15.3042L11.7677 16.4825C10.6737 17.5765 9.18989 18.1911 7.64271 18.1911C6.09554 18.1911 4.61173 17.5765 3.51771 16.4825C2.4237 15.3885 1.80908 13.9047 1.80908 12.3575C1.80908 10.8103 2.4237 9.32653 3.51771 8.23251L4.69688 7.05418L5.87521 8.23418L4.69688 9.41251C4.30719 9.7988 3.99763 10.2583 3.78599 10.7645C3.57434 11.2708 3.46477 11.8138 3.46357 12.3625C3.46237 12.9112 3.56956 13.4548 3.77898 13.962C3.98841 14.4691 4.29595 14.9299 4.68395 15.3179C5.07194 15.7059 5.53276 16.0135 6.03993 16.2229C6.5471 16.4323 7.09064 16.5395 7.63935 16.5383C8.18806 16.5371 8.73113 16.4276 9.23738 16.2159C9.74363 16.0043 10.2031 15.6947 10.5894 15.305L11.7677 14.1267L12.9469 15.3042ZM12.3569 6.46501L13.536 7.64418L7.64355 13.5358L6.46438 12.3575L12.3569 6.46501Z",
    fill: "#3C92FE"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3168_9509" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1b072632><g clip-path=\"url(#clip0_2707_68331)\" data-v-1b072632><path d=\"M10.3451 4.16667H17.5001C17.7211 4.16667 17.9331 4.25446 18.0893 4.41074C18.2456 4.56702 18.3334 4.77899 18.3334 5V16.6667C18.3334 16.8877 18.2456 17.0996 18.0893 17.2559C17.9331 17.4122 17.7211 17.5 17.5001 17.5H2.50008C2.27907 17.5 2.06711 17.4122 1.91083 17.2559C1.75455 17.0996 1.66675 16.8877 1.66675 16.6667V3.33333C1.66675 3.11232 1.75455 2.90036 1.91083 2.74408C2.06711 2.5878 2.27907 2.5 2.50008 2.5H8.67841L10.3451 4.16667ZM10.8334 10.8333V7.5H9.16675V10.8333H6.66675L10.0001 14.1667L13.3334 10.8333H10.8334Z\" fill=\"#3C92FE\" data-v-1b072632></path></g><defs data-v-1b072632><clipPath id=\"clip0_2707_68331\" data-v-1b072632><rect width=\"20\" height=\"20\" fill=\"white\" data-v-1b072632></rect></clipPath></defs></svg>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_modal = _resolveComponent("as-modal")!

  return (_ctx.doc.url)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["cMaterial_link", {
        '-icon': _ctx.icon
      }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlerClick && _ctx.handlerClick(...args)))
        }, [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.doc.title), 1)
        ], 2),
        (_ctx.isModal)
          ? (_openBlock(), _createBlock(_component_as_modal, {
              key: 0,
              "model-value": _ctx.isShowModal,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false)),
              "type-modal": "fullSize"
            }, {
              default: _withCtx(() => [
                _createElementVNode("iframe", {
                  src: _ctx.doc.url,
                  class: "cMaterial_iframe"
                }, null, 8, _hoisted_6)
              ]),
              _: 1
            }, 8, ["model-value"]))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.doc.file)
      ? (_openBlock(), _createElementBlock("a", {
          key: _ctx.doc.id,
          class: _normalizeClass(["cMaterial_doc", `-${_ctx.doc.file.type}`]),
          href: _ctx.doc.file.url,
          target: "_blank"
        }, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_ctx.doc.title), 1)
        ], 10, _hoisted_7))
      : _createCommentVNode("", true)
}